export function StarIcon({
  size = 22,
  filled = false,
}: {
  size?: number;
  filled?: boolean;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <polygon
        points="100,18 122,72 180,76 138,114 150,172 100,142 50,172 62,114 20,76 78,72"
        fill={filled ? "currentColor" : "none"}
        stroke="currentColor"
        strokeWidth="10"
        strokeLinejoin="round"
      />
    </svg>
  );
}
